module.exports = __webpack_public_path__ + "img/1fab7.41b075e.svg";